import React, { useState } from 'react';
import Home from './Home.component';
import LandingLayout from '../../layouts/LandingLayout';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';

const HomeContainer = () => {
  const [sectionClicked, setSectionClicked] = useState(null);
  const scrollToSection = (sectionName) => {
    setSectionClicked(sectionName);
  };

  return (
    <LandingLayout>
      <Navbar scrollToSection={scrollToSection} />
      <Home sectionClicked={sectionClicked} />
      <Footer />
    </LandingLayout>
  );
};

export default HomeContainer;
